// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import styles from './FeaturedNewsItem.styles.js';
import {Image} from 'app/components/Image';
import {Category} from 'app/components/Category';
import {PostActions} from 'app/components/PostActions';

type Props = {
  classes: any,
  data: any
};

class FeaturedNewsItem extends React.Component<Props> {

  static defaultProps = {
    data: {}
  };
  
  render() {
    const {classes, data} = this.props;
    const category = (data.category && data.category[0]) || {};
    return (
      <div className={classes.wrapper}>
        <div className={classes.thumbnailWrapper}>
          <Image
            className={classes.thumbnail}
            src={data.thumbnail}
            alt={data.alt}
            cover
            placeholder
            fill
            block
            overlayShadow
          />
        </div>
        <div className={classes.container}>
          <Typography
            variant="subtitle2"
            component="span"
            className={classes.overTitle}
            gutterBottom
          >
           {data.over_title}
          </Typography>

          <Typography
           variant="subtitle1"
           component="h2"
           className={classes.title}
          >
           <Link to={data.name}> {data.title} </Link>
          </Typography>

          <div className={classes.footer}>
            <Grid container justify={'space-between'} >
              <Grid>
                <Category
                  id={category.id}
                  name={category.name}
                  slug={category.slug}
                />
                {data.author && 
                  <span className={classes.authorName}> | {data.author.name} </span>
                }
              </Grid>
              <Grid>
                <PostActions
                  postId={data.id}
                  initData={{
                    postId: data.id,
                    url: data.name,
                    likes: data.like_count,
                    dislikes: data.dislike_count,
                    comments: data.comment_count
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const Component = withStyles(styles)(FeaturedNewsItem);
export {Component as FeaturedNewsItem};
export default Component;